module.exports = __webpack_public_path__ + "static/media/center-star-icon.a4c383d1.png";